<div class="mt-4 mb-4">
  <!-- <div
    class="price-menu-filter-container"
    #menu
    [ngClass]="{ open: isMenuOpen, hidden: !isMenuOpen }">
    <div class="close-button-container">
      <i id="close-menu" class="icofont-close-line"></i>
    </div>
    <div class="container">
      <div class="filter-item">
        <h3 class="filter-title">Price</h3>
        <div class="filter-contents">
          <button
            *ngFor="let item of catPriceArray"
            [class.highlighted]="priceRange === item.value.toString()"
            (click)="onPriceMenuItemClick(item); toggleMenu()">
            {{ item.name }}
          </button>
        </div>
      </div>
    </div>
  </div> -->

  <div *ngIf="screenWidth <= 774" class="nav-wrapper">
    <nav class="nav-scroller">
      <div class="nav-item"></div>
      <div class="nav-item" *ngFor="let item of subCategoryArray">
        <button
          class="cta-category"
          [ngClass]="{ active: item._id === subCategoryId }"
          (click)="setActiveCategory(item._id); onNavBarClick(item)">
          {{ item.categoryName }}
        </button>
      </div>
    </nav>
    <!-- <button class="filter-button" #toggleButton (click)="toggleMenu()">
      <i class="ri-equalizer-line" style="pointer-events: none"></i>
    </button> -->
    <div class="filter-button" (click)="onPriceFilter()">
      <i class="ri-equalizer-line"></i>
      <span>Filter</span>
    </div>
  </div>

  <!-- In Mobile View start -->

  <div *ngIf="screenWidth <= 774" class="container-fluid mt-4 mb-4">
    <app-loading *ngIf="loading"></app-loading>

    <div class="price-chip mb-4" *ngIf="priceRange">
      <span class="text">{{ priceRange }}</span>
      <i class="ri-close-line" (click)="onClearPriceFilter()"></i>
    </div>

    <div class="error-message" *ngIf="!data.length">
      <img src="assets/images/no-data-found.png" alt="" />
      {{ errorMessage }}
    </div>

    <div *ngIf="!loading && data.length">
      <div class="row">
        <div *ngFor="let idx of data; let i = index" class="col-lg-3 col-md-4 col-sm-6 pb-4">
          <div class="main-container">
            <div class="overlay-btn-continer">
              <a [routerLink]="['/product/', idx?._id]">
                <img
                  class="main-product-image"
                  loading="lazy"
                  [src]="
                    idx?.defaultSubProduct?.images?.length
                      ? idx?.defaultSubProduct?.images[0]?.linkMd
                      : idx?.imageLink
                  "
                  [alt]="idx?.productName + '\'s Image'" />
              </a>
              <div *ngIf="idx?.defaultSubProduct?.discount" class="discount-overlay">
                <span>
                  {{
                    idx?.defaultSubProduct?.discountType === 'CENT'
                      ? idx?.defaultSubProduct?.discount + '%'
                      : 'Flat ' + (idx?.currency || '₹') + ' ' + idx?.defaultSubProduct?.discount
                  }}
                  {{ idx?.defaultSubProduct?.cashBack ? 'Cashback' : 'off' }}
                </span>
                <span *ngIf="idx?.defaultSubProduct?.discountUpto" class="upto-price">
                  {{
                    '(Upto ' + (idx?.currency || '₹') + idx?.defaultSubProduct?.discountUpto + ')'
                  }}
                </span>
              </div>
              <div *ngIf="logedIn" class="inside-overlay">
                <mat-icon
                  class="icon-black"
                  *ngIf="idx?.defaultSubProduct && !idx?.defaultSubProduct?.inWishList"
                  (click)="onAddWishlist(idx.defaultSubProduct, i, true, idx)"
                  title="Add Wishlist">
                  favorite_border
                </mat-icon>
                <mat-icon
                  class="icon-red"
                  *ngIf="idx?.defaultSubProduct && idx?.defaultSubProduct?.inWishList"
                  (click)="onAddWishlist(idx.defaultSubProduct, i, false, idx)"
                  title="Remove Wishlist">
                  favorite
                </mat-icon>
              </div>
            </div>
            <div class="product-content">
              <a class="product-label" [routerLink]="['/product/', idx?._id]">
                <div>
                  <!-- {{ idx.productName | slice : 0 : 60 }} -->
                  <!-- {{ idx.productName.length > 60 ? '.....' : '' }} -->
                  {{ idx.productName }}
                </div>
              </a>
              <div fxLayout="row" fxLayoutAlign="space-between center">
                <p
                  [routerLink]="['/product/', idx?._id]"
                  style="
                    font-size: 16px;
                    cursor: pointer;
                    font-weight: 300;
                    font-family: sans-serif;
                    margin: 10px 0px;
                  ">
                  <span style="color: #1f1f1f; font-size: 17px; font-weight: 600">
                    {{ idx.currency ? idx.currency : '₹' }} {{ idx?.defaultSubProduct?.price }}
                  </span>
                  <del
                    *ngIf="
                      !idx?.defaultSubProduct?.cashBack &&
                      idx?.defaultSubProduct?.price !== idx?.defaultSubProduct?.actualPrice
                    "
                    style="color: #abadae; font-size: 13px">
                    {{ idx?.defaultSubProduct?.actualPrice }}
                  </del>
                </p>
              </div>
              <div class="variant-container">
                <div
                  class="variant-quantity-holder"
                  [class.pointer]="idx.subProducts.length > 1"
                  [class.no-click]="idx.subProducts.length <= 1"
                  (click)="idx.subProducts.length > 1 && openVariantDialog(idx, i)">
                  <p class="product-quantity">
                    <span class="quantity">
                      {{ idx?.defaultSubProduct?.quantity }}
                      <span *ngIf="idx?.defaultSubProduct?.unitValue">
                        - {{ idx?.defaultSubProduct?.unitValue }}
                      </span>
                      <span *ngIf="idx?.defaultSubProduct?.unit">
                        {{ idx?.defaultSubProduct?.unit }}
                      </span>
                    </span>
                    <i class="ri-arrow-down-s-line" *ngIf="idx.subProducts.length > 1"></i>
                  </p>
                </div>
              </div>
              <div fxLayout="row" fxLayoutAlign="start start">
                <div
                  class="out-of-stock-button"
                  *ngIf="idx?.defaultSubProduct?.availableQuantity < 1">
                  Out Of Stock
                </div>
                <div *ngIf="idx?.defaultSubProduct?.availableQuantity > 0">
                  <div *ngIf="!idx?.btnSpinner">
                    <div
                      class="add-to-cart-button"
                      *ngIf="idx?.defaultSubProduct?.selectedQuantity < 1"
                      (click)="onAddCart(idx?.defaultSubProduct, i, idx)">
                      <i class="icofont-cart"></i>
                      Add To Cart
                    </div>
                  </div>
                  <div
                    class="view-cart-button"
                    *ngIf="idx?.defaultSubProduct?.selectedQuantity > 0"
                    [routerLink]="['/cart']">
                    <i class="icofont-cart"></i>
                    View Cart
                  </div>
                  <div
                    style="width: 150px; height: 40px; background: transparent"
                    class="mat-spinner-black"
                    *ngIf="idx.btnSpinner"
                    fxLayoutAlign="space-around center">
                    <mat-spinner [diameter]="38"></mat-spinner>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- In Mobile View end -->

  <div *ngIf="screenWidth > 774" class="container-fluid mt-4 mb-4">
    <div class="row">
      <div *ngIf="categoryArray.length" class="col-2 col-md-2 fixed-sidebar">
        <div style="background-color: rgba(0, 0, 0, 0.08)">
          <nav class="nav-scroller">
            <!-- <button class="toggle-filter-button" #toggleButton (click)="toggleMenu()">
              Filter
              <i class="ri-filter-3-line" style="pointer-events: none"></i>
            </button> -->
            <div class="price-filter-container">
              <div class="price-filters">
                <label>Price</label>
                <mat-radio-group [(ngModel)]="checkedPriceRange">
                  <ul>
                    <li *ngFor="let idx of catPriceArray">
                      <mat-radio-button [value]="idx.value" (change)="onChangePrice(idx)">
                        {{ idx.name }}
                      </mat-radio-button>
                    </li>
                  </ul>
                </mat-radio-group>
              </div>
              <span *ngIf="checkedPriceRange">
                <i class="ri-refresh-line" (click)="onClearPriceFilter()">Reset Price</i>
              </span>
            </div>
            <div class="category-items-container">
              <label>Categories</label>
              <div class="navigation-items-container" *ngFor="let category of categoryArray">
                <p class="navigation-item" (click)="toggleSubCategories(category)">
                  <span>{{ category.categoryName.toLowerCase() }}</span>
                  <i class="ri-arrow-right-s-line" [ngClass]="{ rotate: isCategoryOpen(category) }">
                  </i>
                </p>
                <div class="sub-categories-holder" [hidden]="!isCategoryOpen(category)">
                  <p
                    (click)="onSideBarItemClick(category, subcats)"
                    class="sub-category-item"
                    [ngClass]="{ active: subcats._id === subCategoryId }"
                    *ngFor="let subcats of category.subCategoriesInfo">
                    {{ subcats.categoryName }}
                  </p>
                </div>
              </div>
            </div>
          </nav>
        </div>
      </div>
      <app-loading *ngIf="loading"></app-loading>
      <div [ngClass]="!categoryArray.length && !data.length ? 'col-12' : 'col-10'" *ngIf="!loading">
        <div class="error-message" *ngIf="!data.length">
          <img src="assets/images/no-data-found.png" alt="" />
          {{ errorMessage }}
        </div>
        <div class="row" *ngIf="data.length">
          <div *ngFor="let idx of data; let i = index" class="col-lg-3 col-md-4 col-sm-6 pb-4">
            <div class="main-container">
              <div class="overlay-btn-continer">
                <a [routerLink]="['/product/', idx?._id]">
                  <img
                    class="main-product-image"
                    loading="lazy"
                    [src]="
                      idx?.defaultSubProduct?.images?.length
                        ? idx?.defaultSubProduct?.images[0]?.linkMd
                        : idx?.imageLink
                    "
                    [alt]="idx?.productName + '\'s Image'" />
                </a>
                <div *ngIf="logedIn" class="inside-overlay">
                  <mat-icon
                    class="icon-black"
                    *ngIf="idx?.defaultSubProduct && !idx?.defaultSubProduct?.inWishList"
                    (click)="onAddWishlist(idx.defaultSubProduct, i, true, idx)"
                    title="Add Wishlist">
                    favorite_border
                  </mat-icon>
                  <mat-icon
                    class="icon-red"
                    *ngIf="idx?.defaultSubProduct && idx?.defaultSubProduct?.inWishList"
                    (click)="onAddWishlist(idx.defaultSubProduct, i, false, idx)"
                    title="Remove Wishlist">
                    favorite
                  </mat-icon>
                </div>
                <div *ngIf="idx?.defaultSubProduct?.discount" class="discount-overlay">
                  <span>
                    {{
                      idx?.defaultSubProduct?.discountType === 'CENT'
                        ? idx?.defaultSubProduct?.discount + '%'
                        : 'Flat ' + (idx?.currency || '₹') + ' ' + idx?.defaultSubProduct?.discount
                    }}
                    {{ idx?.defaultSubProduct?.cashBack ? 'Cashback' : 'off' }}
                  </span>
                  <span *ngIf="idx?.defaultSubProduct?.discountUpto" class="upto-price">
                    {{
                      '(Upto ' + (idx?.currency || '₹') + idx?.defaultSubProduct?.discountUpto + ')'
                    }}
                  </span>
                </div>
              </div>
              <div class="product-content">
                <a class="product-label" [routerLink]="['/product/', idx?._id]">
                  <div>
                    <!-- {{ idx.productName | slice : 0 : 60 }} -->
                    <!-- {{ idx.productName.length > 60 ? '.....' : '' }} -->
                    {{ idx.productName }}
                  </div>
                </a>
                <div class="price-section" fxLayout="row" fxLayoutAlign="space-between center">
                  <p [routerLink]="['/product/', idx?._id]">
                    <span>
                      {{ idx.currency ? idx.currency : '₹' }} {{ idx?.defaultSubProduct?.price }}
                    </span>
                    <del
                      *ngIf="
                        !idx?.defaultSubProduct?.cashBack &&
                        idx?.defaultSubProduct?.price !== idx?.defaultSubProduct?.actualPrice
                      ">
                      {{ idx?.defaultSubProduct?.actualPrice }}
                    </del>
                  </p>
                </div>
                <div class="variant-container">
                  <div
                    class="variant-quantity-holder"
                    [class.pointer]="idx.subProducts.length > 1"
                    [class.no-click]="idx.subProducts.length <= 1"
                    (click)="idx.subProducts.length > 1 && openVariantDialog(idx, i)">
                    <p class="product-quantity">
                      <span class="quantity">
                        {{ idx?.defaultSubProduct?.quantity }}
                        <span *ngIf="idx?.defaultSubProduct?.unitValue">
                          - {{ idx?.defaultSubProduct?.unitValue }}
                        </span>
                        <span *ngIf="idx?.defaultSubProduct?.unit">
                          {{ idx?.defaultSubProduct?.unit }}
                        </span>
                      </span>
                      <i class="ri-arrow-down-s-line" *ngIf="idx.subProducts.length > 1"></i>
                    </p>
                  </div>
                </div>
                <div fxLayout="row" fxLayoutAlign="start start">
                  <div
                    class="out-of-stock-button"
                    *ngIf="idx?.defaultSubProduct?.availableQuantity < 1">
                    Out Of Stock
                  </div>
                  <div *ngIf="idx?.defaultSubProduct?.availableQuantity > 0">
                    <div *ngIf="!idx?.btnSpinner">
                      <div
                        class="add-to-cart-button"
                        *ngIf="idx?.defaultSubProduct?.selectedQuantity < 1"
                        (click)="onAddCart(idx?.defaultSubProduct, i, idx)">
                        <i class="icofont-cart"></i>
                        Add To Cart
                      </div>
                    </div>
                    <div
                      class="view-cart-button"
                      *ngIf="idx?.defaultSubProduct?.selectedQuantity > 0"
                      [routerLink]="['/cart']">
                      <i class="icofont-cart"></i>
                      View Cart
                    </div>
                    <div
                      style="width: 150px; height: 40px; background: transparent"
                      class="mat-spinner-black"
                      *ngIf="idx.btnSpinner"
                      fxLayoutAlign="space-around center">
                      <mat-spinner [diameter]="38"></mat-spinner>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="paginator" *ngIf="data.length || pSkip">
    <p class="p-text">Items per page:</p>
    <mat-form-field style="width: 70px" appearance="outline">
      <mat-select [(ngModel)]="pLimit" (selectionChange)="onPageSizeChange()">
        <mat-option *ngFor="let idx of pageSizeList" [value]="idx">
          {{ idx }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <div fxLayout="row" fxLayoutAlign="end center">
      <p class="p-text">Page {{ pSkip + 1 }}</p>
    </div>
    <div fxLayout="row" fxLayoutAlign="center center">
      <button
        [disabled]="pSkip === 0"
        mat-icon-button
        (click)="onPreviousPage()"
        matTooltip="Previous Page">
        <mat-icon>chevron_left</mat-icon>
      </button>
      <button
        [disabled]="data.length < pLimit"
        mat-icon-button
        (click)="onNextPage()"
        matTooltip="Next Page">
        <mat-icon>chevron_right</mat-icon>
      </button>
    </div>
  </div>
</div>
